/**
 * Frontend structured logger.
 *
 * Thin wrapper around `@revalize/monitoring/frontend`'s `createLogger`. When
 * `initializeMonitoring()` has run with a Sentry-enabled config (see
 * `frontend/src/main.tsx`), logger calls are forwarded to Sentry as breadcrumbs
 * and to Sentry Logs; `logger.error(msg, err)` additionally captures the
 * exception.
 *
 * Usage:
 *   import { logger } from '@/utils/logger'
 *   logger.info('User signed in', { userId })
 *   logger.warn('Token expiring soon', { expiresIn })
 *   logger.error('Failed to save model', err instanceof Error ? err : undefined, { modelId })
 *   logger.debug('Render tick', { frame })
 *
 * For a file that wants its own service tag (shows up in Sentry as a
 * `service` attribute), create a scoped logger:
 *
 *   import { createLogger } from '@/utils/logger'
 *   const logger = createLogger({ service: 'AuthCallbackPage' })
 *
 * API shape (message-first, unlike the backend's Pino-style ctx-first):
 *   .error(message, error?, context?)
 *   .warn(message, context?)
 *   .info(message, context?)
 *   .debug(message, context?)
 */

import { createLogger as createMonitoringLogger } from '@revalize/monitoring/frontend'

export { createMonitoringLogger as createLogger }

export const logger = createMonitoringLogger({ service: 'starter-template' })
